import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-institute-anti-ragging-committee',
  templateUrl: './institute-anti-ragging-committee.component.html',
  styleUrls: ['./institute-anti-ragging-committee.component.scss']
})
export class InstituteAntiRaggingCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
